<template>
  <div class="item" id="cardInfo.id">
    <div class="title-box">
    </div>
    <h3>{{title}}</h3>
  </div>
</template>
<script>
  export default {
    props: [
      'title'
    ]
  }
</script>
<style scoped lang="scss">
  @import "../assets/style/mixin";

  .item {
    background-color: #FFFFFF;
    padding: 10px 30px 10px 30px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    margin:10px 10px 10px 10px;
    .title-box{
      width: 8px;
      height: 40px;
      background-color: #A6DCE7;
    }
    h3{
      margin-left: 20px;
      font-size: 25px;
      color: #000000;
    }

  }
</style>



// WEBPACK FOOTER //
// recomIcon.vue?1074f05d